export const menuTitle = { title: "PERIODE", label: "Periode" }
  